import { render } from "./DataFooterWaiter.vue?vue&type=template&id=19c42c68&scoped=true"
import script from "./DataFooterWaiter.vue?vue&type=script&lang=js"
export * from "./DataFooterWaiter.vue?vue&type=script&lang=js"

import "./DataFooterWaiter.vue?vue&type=style&index=0&id=19c42c68&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c42c68"],['__file',"src/components/elements/waiter/DataFooterWaiter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19c42c68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19c42c68', __exports__)) {
    api.reload('19c42c68', __exports__)
  }
  
  module.hot.accept("./DataFooterWaiter.vue?vue&type=template&id=19c42c68&scoped=true", () => {
    api.rerender('19c42c68', render)
  })

}


export default __exports__